<template>
  <div class="landing">
    <h1>WITAJ NA MOJEJ STRONIE</h1>
    <nav>
      <router-link to="/home"><p class="subtitle">Dalej</p></router-link>
    </nav>
  </div>
</template>
<style lang="scss">
.landing {
  margin: 0;
  min-height: 100vh;
  display: grid;
  gap: 2rem;
  place-content: center;
  text-align: center;
  background: var(--bg-color);

  h1 {
    font-size: 2rem;
    position: relative;
    width: max-content;
  }

  h1::before,
  h1::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  h1::before {
    background: var(--bg-color);
    animation: typewriter var(--typewriterSpeed)
      steps(var(--typewriterCharacters)) 1s forwards;
  }

  h1::after {
    width: 0.125em;
    background: black;
    animation: typewriter var(--typewriterSpeed)
        steps(var(--typewriterCharacters)) 1s forwards,
      blink 750ms steps(var(--typewriterCharacters)) infinite;
  }

  a {
    cursor: pointer;
    display: inline-block;
    transition: all 0.3s ease-out;

    &:hover {
      transform: translateY(-3px);
    }

    &:active {
      transform: translateY(-1px);
    }
  }

  .subtitle {
    font-size: 1.5rem;
    font-weight: 400;
    opacity: 0;
    transform: translateY(3rem);
    animation: fadeInUp 2s ease calc(var(--typewriterSpeed) + 2s) forwards;
  }
}
@keyframes typewriter {
  to {
    left: 100%;
  }
}

@keyframes blink {
  to {
    background: transparent;
  }
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
